<template>
  <div class="min-h-screen pt-8">
    <header
      class="mx-auto mb-8 max-w-5xl px-4 text-center text-sm uppercase tracking-[0.2em] text-neutral-600"
    >
      Test Header
    </header>
    <main class="mx-auto max-w-5xl px-4">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })
</script>
